import React from "react";
import APIManager from "../../services/api-manager";
import ReviewPagination from './pagination';

export default class ReviewForm extends React.Component {

    constructor(props) {
        super(props);

        this.APIManager = new APIManager();

        this.state = {
            page: this.props.page,
            reviews: null,
            summaryRating: null,
            summaryTotal: null,
            totalPages: 226,
            loading: true
        };
    }

    componentDidMount = () => {
        this.handleChange(this.state.page);
    };

    onWindowPopstate = (event) => {
        this.setState({searchParams: event.state ? event.state : this.props.page}, () => this.handleChange(false));
    };

    handleChange = (page, pushPopState) => {
        this.setState({loading:true},
            this.APIManager.getReviews(
                page,
                response => this.onChange(response, pushPopState),
                error => console.error(error)
            )
        )
    };

    onChange = (response, pushPopState) => {
        this.setState({loading: false, ...response}, () => {
            document.documentElement.scrollTop = 0;
            if (pushPopState) history.pushState(this.state.page, 'reviews', `${window.location.pathname}?page=${this.state.page}`);
        });
    };

    renderPagination = () => <ReviewPagination onChange={(page) => {
        this.handleChange(page, true)
    }} page={this.state.page} totalPages={this.state.totalPages}/>;

    renderStars = (review) => {


        return <p className="feefo-review--rating">{stars}</p>
    }

    renderReview(review) {
        let date = new Date(review.last_updated_date);
        let rating = review.service.rating.rating;
        let stars = [];
        let comments = [];
        let showComment = false;

        for (let i = 0; i < 5; i++) {
            if (i <= rating) {
                stars.push(<i className="fa fa-star"></i>)
            } else if (i > rating && i < rating + 1) {
                stars.push(<i className="fa fa-star-half-empty"></i>)
            } else if (i > rating) {
                stars.push(<i className="fa fa-star-o"></i>)
            }
        }

        if(typeof review.service != "undefined" && typeof review.service.thread != "undefined") {
            review.service.thread.forEach( (comment) => {
                if (comment && (comment.type == 'MERCHANT_COMMENT' || comment.type == 'CUSTOMER_COMMENT') ) {
                    showComment = true;
                    comments.push(<div className={ comment.type == 'CUSTOMER_COMMENT' ? "feefo-review--comment customer": "feefo-review--comment" }>
                        <p>{comment.comment}</p>
                        { comment.author && <p className="feefo-review--author">{ comment.type == 'MERCHANT_COMMENT' ? comment.author + " at ROL Cruise": comment.author } </p> }
                    </div>)
                }
            })
        }

        return (<>
            <div className="feefo-review">
                {review.service.title && <h4 className="feefo-review--heading">{review.service.title}</h4>}
                <p className="">{ date.getDayOrdinal()+' '+date.getMonthName()+' '+date.getFullYear() }</p>
                <p className="feefo-review--text">{review.service.review}</p>
                <p className="feefo-review--rating">{stars}</p>
                { showComment && <p className="feefo-review--thread"><i className="fa fa-comment"></i></p>}
            </div>

            {comments}
        </>)
    }

    renderloading = () =>  <div className="loading">
        <p className="loading-title">LOADING</p>
        <div className="spinner">
            <div className="rect1"></div>
            <div className="rect2"></div>
            <div className="rect3"></div>
            <div className="rect4"></div>
            <div className="rect5"></div>
        </div>
    </div>

    render() {
        if (this.state.loading || !this.state.reviews || this.state.reviews.length < 1) return  this.renderloading()

        return <>
            {this.state.reviews.map( this.renderReview )}
            {this.renderPagination()}
        </>
    }
}